import { phoneInputKey } from '.';
export var createPhoneInputDriver = function (wrapper) {
    var base = wrapper.$("." + phoneInputKey);
    return {
        getNumber: function () { return base.$('input[type="tel"]').value(); },
        enterNumber: function (num) { return base.$('input[type="tel"]').enterValue(num); },
        isDisabled: function () { return wrapper.$("." + phoneInputKey + ".is-disabled").exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map